/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 13/11/2013
 * Time: 09:04
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('UserAction_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/userActions/:id', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'},
        getUserActionFromDate: {method: 'POST', isArray: false, url: baseUrl + 'rest/userActions/date'},
        getUserActionBooking: {method: 'POST', isArray: false, url: baseUrl + 'rest/userActions/booking'}
    });
}]);

angular.module('FlexyBeautyApp.services')
    .factory('UserAction',
        ["UserAction_Resource", "HumanResourceData", "ObjectModification", "gettextCatalog",
            function (UserAction_Resource, HumanResourceData, ObjectModification, gettextCatalog) {

                let userAction = function (userActionRes, loadObjectModifications) {
                    this.id = null;
                    this.author = null; //humanResource (generate after global Load)
                    this.authorId = null; //humanResourceId
                    this.actionDate = null;
                    this.globalType = null;
                    this.globalObjectType = null;
                    this.cancelable = true;
                    this.description = "";
                    this.objectModifications = [];

                    if (userActionRes !== undefined && userActionRes != null) {
                        var msg = gettextCatalog.getString("Annuler la"),
                            msgCreate = gettextCatalog.getString("création"),
                            msgDelete = gettextCatalog.getString("suppression"),
                            msgUpdate = gettextCatalog.getString("modification"),
                            msgCustomer = gettextCatalog.getString("du client"),
                            msgDay = gettextCatalog.getString("de la journée"),
                            msgBooking = gettextCatalog.getString("de la réservation"),
                            msgUnavailable = gettextCatalog.getString("de l'indisponibilité");
                        (!this.id)
                        this.id = userActionRes.id;
                        this.cancelable = userActionRes.cancelable;
                        if (userActionRes.actionDate)
                            this.actionDate = new Date(userActionRes.actionDate);
                        this.authorId = userActionRes.authorId;
                        this.globalType = userActionRes.globalType;
                        this.globalObjectType = userActionRes.globalObjectType;
                        this.author = HumanResourceData.getById(userActionRes.authorId);
                        this.description = msg + " ";
                        switch (this.globalType) {
                            case "delete":
                                this.description += msgDelete;
                                break;
                            case "update":
                                this.description += msgUpdate;
                                break;
                            case "create":
                                this.description += msgCreate;
                                break;
                        }
                        switch (this.globalObjectType) {
                            case "Customer":
                                this.description += " " + msgCustomer;
                                break;
                            case "Booking":
                                this.description += " " + msgBooking;
                                break;
                            case "BookingService":
                                this.description += " " + msgBooking;
                                break;
                            case "Activity":
                                this.description += " " + msgUnavailable;
                                break;
                            default:
                                this.description = null;
                                break;
                        }
                        if (this.description)
                            this.description += " ?";


                        if (loadObjectModifications !== undefined && loadObjectModifications) {
                            this.objectModifications = [];
                            for (var i = 0; i < userActionRes.objectModifications.length; i++) {
                                var objModification = new ObjectModification(userActionRes.objectModifications[i]);
                                objModification.currentVersion = userActionRes.objectModifications[i].currentVersion;
                                objModification.previousVersion = userActionRes.objectModifications[i].previousVersion;
                                this.objectModifications.push(objModification);
                            }
                        }
                    }
                    userAction.prototype.getCancelRequest = function () {
                        var rsUserAction = new UserAction_Resource();
                        rsUserAction.id = this.id;
                        return rsUserAction;
                    }
                };
                return userAction;
            }]);

angular.module('FlexyBeautyApp.services')
    .factory('ObjectModification', [function () {
        return function (object) {
            this.type = object.type;//create / update / delete
            this.objectId = object.objectId;
            this.currentVersion = null;
            this.previousVersion = null;
        };
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('UserActionSrv', ["$log", "$timeout", "UserAction_Resource", "Decorators", "TimeMeasures",
        function ($log, $timeout, UserAction_Resource, Decorators, TimeMeasures) {
            var userActionSrv = {
                autoUpdatePromise: null
            };

            userActionSrv.get = function (id, successFunction, errorFunction) {
                UserAction_Resource.get({id: id}, //params
                    function (userActionResource) {
                        if (successFunction) {
                            successFunction(userActionResource);
                        }
                    },
                    function (data) {
                        if (errorFunction) {
                            errorFunction(data);
                        }
                    }
                );
            };

            userActionSrv.getUserActionFromDate = Decorators.timeMeasureDecorator(
                (fromDate) => {
                    let actionRes = new UserAction_Resource();
                    actionRes.fromDate = fromDate;
                    return actionRes.$getUserActionFromDate({});
                },
                TimeMeasures.USER_ACTION_FROM_DATE
            );

            userActionSrv.getUserActionBooking = Decorators.timeMeasureDecorator(
                (fromDate) => {
                    let actionRes = new UserAction_Resource();
                    actionRes.fromDate = fromDate;
                    return actionRes.$getUserActionBooking({});
                },
                TimeMeasures.USER_ACTION_BOOKING
            );

            return userActionSrv;
        }]);

angular.module('FlexyBeautyApp.services').factory('UserActionManager', ["$log", "$rootScope", "$timeout", "ServerSrv", "MessageSrv", "UserActionData", "HumanResourceSrv", "CategorySrv", "ServiceSrv", "BookingSrv",
    "BookingServiceSrv", "SaleSrv", "SaleServiceSrv", "SaleProductSrv", "SaleCureSrv", "SiteSrv", "WorkingPeriodDayHrSrv", "WorkingPeriodDayPrSrv", "ActivitySrv", "ObjectModification", "DayHrSrv",
    "DayPrSrv", "CustomerSrv", "Activity", "BookingService", "DayHr", "DayPr", "GiftItemSrv", "CureItemSrv", "CureItemToServiceSrv", "CureItemToServiceUsageSrv", "LoyaltyCardItemSrv",
    "PosOpSrv", "OrderSrv", "OrderProductSrv", "CheckDepositSrv", "UsageProductSrv", "ProductSrv", "UserActionSrv", "ClosureSrv", "DashboardSrv", "DashboardSchedulerSrv", "OptInOutSrv",
    "Constants", "$interval",
    function ($log, $rootScope, $timeout, ServerSrv, MessageSrv, UserActionData, HumanResourceSrv, CategorySrv, ServiceSrv, BookingSrv,
              BookingServiceSrv, SaleSrv, SaleServiceSrv, SaleProductSrv, SaleCureSrv, SiteSrv, WorkingPeriodDayHrSrv, WorkingPeriodDayPrSrv, ActivitySrv, ObjectModification, DayHrSrv,
              DayPrSrv, CustomerSrv, Activity, BookingService, DayHr, DayPr, GiftItemSrv, CureItemSrv, CureItemToServiceSrv, CureItemToServiceUsageSrv, LoyaltyCardItemSrv,
              PosOpSrv, OrderSrv, OrderProductSrv, CheckDepositSrv, UsageProductSrv, ProductSrv, UserActionSrv, ClosureSrv, DashboardSrv, DashboardSchedulerSrv, OptInOutSrv,
              Constants, $interval) {

        let userActionSrv = {
            currentPopDate : null,
            nextPopDate : null,
            popInterval : undefined
        };

        userActionSrv.stopPopInterval = () => {
            console.info("Cancellation of userAction pop interval");
            if (angular.isDefined(userActionSrv.popInterval)) {
                $interval.cancel(userActionSrv.popInterval);
                userActionSrv.popInterval = undefined;
            }
        }

        userActionSrv.executeUserActionPop = (onAuthenticationLost) => {
            userActionSrv.nextPopDate = new Date();
            console.info("Current time : " + new Date() + "; Asking userAction/date with popDate " + userActionSrv.currentPopDate);
            UserActionSrv.getUserActionFromDate(userActionSrv.currentPopDate).then(
                (data) => {
                    let userActionsRes = data ? data.userActions : {};
                    if (userActionsRes) {
                        for (let i = 0; i < userActionsRes.length; i++) {
                            if (!UserActionData.getExternal(userActionsRes[i].id) && !UserActionData.get(userActionsRes[i].id) && !UserActionData.getCanceled(userActionsRes[i].id))  //not already processed
                                userActionSrv.executeUserAction(userActionsRes[i], true);
                        }
                    }
                    userActionSrv.currentPopDate = userActionSrv.nextPopDate;
                },
                (data) => {
                    if (data && data.status && data.status === 401) {
                        onAuthenticationLost();
                    }
                }
            );
        }

        userActionSrv.startUserActionPop = function (onAuthenticationLost, intervalInMillisecond) {
            console.info("Creation of userAction pop interval");
            userActionSrv.popInterval = $interval(userActionSrv.executeUserActionPop, intervalInMillisecond, null, null, onAuthenticationLost);
            return userActionSrv.popInterval;
        }

        userActionSrv.orderByModelHierarchy = function (objectModifications) {
            // Order objects modification in order to manage in first leaves of model hierarchy
            var orderedObjModifs = [];
            var objectModificationsCopy = objectModifications.slice();
            var modelHierarchy = [
                "User",
                "Customer",
                "HumanResource",
                "PhysicalResource",
                "Service",
                "Product",
                "Cure",
                "LoyaltyCard",
                "Supplier",
                "Category",
                "ProductCategory",
                "CureCategory",
                "LoyaltyCardCategory",
                "Site",
                "WorkingPeriod",
                "WorkingPeriodDay",
                "WorkingPeriodDayHr",
                "WorkingPeriodDayPr",
                "Day",
                "DayHr",
                "DayPr",
                "Sale",
                "SaleProduct",
                "SaleService",
                "SaleCure",
                "GiftItem",
                "LoyaltyCardItem",
                "Booking",
                "BookingService",
                "Activity",
                "CureItem",
                "CureItemToService",
                "CureItemToServiceUsage",
                "PosOp",
                "Order",
                "OrderProduct",
                "CheckDeposit",
                "UsageProduct",
                "Vat",
                "OtherPaymentType",
                "App",
                "Closure",
                "Dashboard",
                "DashboardScheduler",
                "OptInOut"];

            //first adding or update  : add dayHr before activity
            var i, j;
            for (i = 0; i < modelHierarchy.length && objectModificationsCopy.length > 0; i++) {
                for (j = 0; j < objectModificationsCopy.length;) {
                    if (objectModificationsCopy[j].type !== "delete" && objectModificationsCopy[j].currentVersion.objectType === modelHierarchy[i]) {
                        orderedObjModifs.push(objectModificationsCopy[j]);
                        objectModificationsCopy.splice(j, 1);
                    } else
                        j++;
                }
            }
            //now remove : inverse order hierarchy : remove activity before day hre
            for (i = modelHierarchy.length; i >= 0 && objectModificationsCopy.length > 0; i--) {
                for (var j = 0; j < objectModificationsCopy.length;) {
                    if (objectModificationsCopy[j].type === "delete" && objectModificationsCopy[j].currentVersion.objectType === modelHierarchy[i]) {
                        orderedObjModifs.push(objectModificationsCopy[j]);
                        objectModificationsCopy.splice(j, 1);
                    } else
                        j++;
                }
            }
            if (objectModificationsCopy.length > 0)
                $log.error("objectModificationsCopy not empty. Check " + objectModificationsCopy[0].currentVersion.objectType);
            return orderedObjModifs;
        };

        userActionSrv.getObjectService = function (resourceCurrentVersion, resourcePreviousVersion) {
            var srv = null;
            if (resourceCurrentVersion.objectType) {
                switch (resourceCurrentVersion.objectType) {
                    case "Product":
                        srv = ProductSrv;
                        break;
                    case "Customer":
                        srv = CustomerSrv;
                        break;
                    case "Booking":
                        srv = BookingSrv;
                        break;
                    case "BookingService":
                        srv = BookingServiceSrv;
                        break;
                    case "Sale":
                        srv = SaleSrv;
                        break;
                    case "SaleProduct":
                        srv = SaleProductSrv;
                        break;
                    case "SaleCure":
                        srv = SaleCureSrv;
                        break;
                    case "SaleService":
                        srv = SaleServiceSrv;
                        break;
                    case "GiftItem":
                        srv = GiftItemSrv;
                        break;
                    case "LoyaltyCardItem":
                        srv = LoyaltyCardItemSrv;
                        break;
                    case "DayPr":
                        srv = DayPrSrv;
                        break;
                    case "DayHr":
                        srv = DayHrSrv;
                        break;
                    case "CureItem":
                        srv = CureItemSrv;
                        break;
                    case "CureItemToService":
                        srv = CureItemToServiceSrv;
                        break;
                    case "CureItemToServiceUsage":
                        srv = CureItemToServiceUsageSrv;
                        break;
                    case "PosOp":
                        srv = PosOpSrv;
                        break;
                    case "Order":
                        srv = OrderSrv;
                        break;
                    case "OrderProduct":
                        srv = OrderProductSrv;
                        break;
                    case "CheckDeposit":
                        srv = CheckDepositSrv;
                        break;
                    case "UsageProduct":
                        srv = UsageProductSrv;
                        break;
                    case "Closure":
                        srv = ClosureSrv;
                        break;
                    case "Activity":
                        if (!((resourceCurrentVersion && resourceCurrentVersion.workingPeriodDayHr) ||
                            (resourcePreviousVersion && resourcePreviousVersion.workingPeriodDayHr) ||
                            (resourceCurrentVersion && resourceCurrentVersion.workingPeriodDayPr) ||
                            (resourcePreviousVersion && resourcePreviousVersion.workingPeriodDayPr)))
                            srv = ActivitySrv;
                        break;
                    case "Dashboard":
                        srv = DashboardSrv;
                        break;
                    case "DashboardScheduler":
                        srv = DashboardSchedulerSrv;
                        break;
                    case "OptInOut":
                        srv = OptInOutSrv;
                        break;

                }
            }
            return srv;
        };
        userActionSrv.executeUserAction = function (userActionRes, isNotFromAngularEvent) {
            /** @namespace data.objectModifications */
            /** @namespace data.userAction */
            //must manage "objectsModifications"
            //return userAction
            if (userActionRes.objectModifications && UserActionData.getExternal(userActionRes.id) == null)//not already executed
            {
                UserActionData.addExternal(userActionRes);
                var orderedObjModifs = userActionSrv.orderByModelHierarchy(userActionRes.objectModifications);
                var actionsToEmitToViews = [];
                var allowUpdate = true;
                for (var i = 0; i < orderedObjModifs.length && allowUpdate; i++) {
                    var srv = null;
                    var objModification = new ObjectModification(orderedObjModifs[i]);
                    var resourceCurrentVersion = orderedObjModifs[i].currentVersion;
                    var resourcePreviousVersion = orderedObjModifs[i].previousVersion;
                    srv = userActionSrv.getObjectService(resourceCurrentVersion, resourcePreviousVersion);
                    if (srv) {
                        switch (orderedObjModifs[i].type) {
                            case "create":
                                if (srv.addLocally !== undefined)
                                    objModification.currentVersion = srv.addLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                break;
                            case "update":
                                if (srv.updateLocally !== undefined)
                                    objModification.currentVersion = srv.updateLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                break;
                            case "delete":
                                if (srv.removeLocally !== undefined)
                                    objModification.currentVersion = srv.removeLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                break;

                            case "restore":
                                if (typeof srv.restoreLocally === "function") {
                                    objModification.currentVersion = srv.restoreLocally(orderedObjModifs[i].objectId, resourceCurrentVersion);
                                }
                                break;
                        }
                        if (objModification.currentVersion) {
                            if (resourcePreviousVersion && srv.getPreviousVersionInstance !== undefined)//Defined only for classes that can change of owner //TODO do it for all classes
                                objModification.previousVersion = srv.getPreviousVersionInstance(resourcePreviousVersion);
                            actionsToEmitToViews.push(objModification);
                        } else //version is null (maybe because it's not the last version)
                        if (resourceCurrentVersion.objectType === "Booking" || resourceCurrentVersion.objectType === "Sale")//not the last version of booking refuse other update of bs
                            allowUpdate = false;
                    } else //Action on objects not managed
                    {
                        if (resourceCurrentVersion.objectType !== "App")
                            MessageSrv.send("warning", "Des données de l'établissement ont été modifiées par un autre utilisateur<br/>Vous devez recharger l'application", isNotFromAngularEvent);
                    }
                }
            }
            //Manage internal reference inside previousVersion
            if (allowUpdate) {
                for (let j = 0; j < actionsToEmitToViews.length; j++) {
                    if (actionsToEmitToViews[j].previousVersion instanceof Activity || actionsToEmitToViews[j].previousVersion instanceof BookingService) {
                        let previousActivity = actionsToEmitToViews[j].previousVersion;
                        //check for intance of dayHr inside actionsToEmitToViews
                        if (previousActivity.dayHr)
                            for (let k = 0; k < actionsToEmitToViews.length; k++)
                                if (actionsToEmitToViews[k].currentVersion instanceof DayHr && actionsToEmitToViews[k].currentVersion.id === previousActivity.dayHr.id) {
                                    actionsToEmitToViews[k].previousVersion.id = actionsToEmitToViews[k].currentVersion.id;//set real object id (to allow research)
                                    previousActivity.dayHr = actionsToEmitToViews[k].previousVersion;
                                }
                        if (previousActivity.dayPr)
                            for (let k = 0; k < actionsToEmitToViews.length; k++)
                                if (actionsToEmitToViews[k].currentVersion instanceof DayPr && actionsToEmitToViews[k].currentVersion.id === previousActivity.dayPr.id) {
                                    actionsToEmitToViews[k].previousVersion.id = actionsToEmitToViews[k].currentVersion.id;//set real object id (to allow research)
                                    previousActivity.dayPr = actionsToEmitToViews[k].previousVersion;
                                }
                    }
                }
                for (let j = 0; j < actionsToEmitToViews.length; j++) {
                    $rootScope.$emit("onExternalModelChanged", actionsToEmitToViews[j], isNotFromAngularEvent);
                    console.log(actionsToEmitToViews[j]);
                    //Emit to view ctrl
                }
            }
        };

        return userActionSrv;
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('UserActionData',
        ["$log", "UserAction", "MessageSrv", "$rootScope",
            function ($log, UserAction, MessageSrv, $rootScope) {
                let userActionData = {
                    userActions: [], //actions done by logged user
                    userActionsCanceled: [], //actions canceled by logged user
                    externalUserActions: [] //actions receive by channel communication
                };

                userActionData.get = function (userActionId) {
                    for (let i = 0; i < this.userActions.length; i++)
                        if (this.userActions[i].id === userActionId)
                            return this.userActions[i];
                    return null;
                };

                userActionData.getExternal = function (userActionId) {
                    if (userActionId === undefined || userActionId === null) {
                        return null;
                    }

                    for (let i = 0; i < this.externalUserActions.length; i++) {
                        if (this.externalUserActions[i].id === userActionId) {
                            return this.externalUserActions[i];
                        }
                    }

                    return null;
                };

                userActionData.getCanceled = function (userActionId) {
                    for (let i = 0; i < this.userActionsCanceled.length; i++)
                        if (this.userActionsCanceled[i].id === userActionId)
                            return this.userActionsCanceled[i];
                    return null;
                };

                userActionData.getLastUserAction = function () {
                    if (this.userActions.length > 0)
                        return this.userActions[this.userActions.length - 1];
                    return null;
                };

                userActionData.getLastUserActionCanceled = function () {
                    if (this.userActionsCanceled.length > 0) {
                        return this.userActionsCanceled[this.userActionsCanceled.length - 1];
                    }
                    return null;
                };

                userActionData.add = function (userActionRes) {
                    if (userActionRes && !userActionData.get(userActionRes.id)) {
                        let userAction = new UserAction(userActionRes);
                        this.userActions.push(userAction);
                        this.userActionsCanceled = []; //When a new action occurs redo is reset
                        if (userAction.globalObjectType !== "Sale") { //sales actions can't be canceled
                            $rootScope.$emit("onChangeUserActionToCancel", userAction);
                        }
                    }
                };

                userActionData.addExternal = function (userActionRes) {
                    let userAction = null;
                    if (userActionRes && !userActionData.getExternal(userActionRes.id)) {
                        userAction = new UserAction(userActionRes);
                        this.externalUserActions.push(userAction);
                    }
                    return userAction;
                };

                userActionData.addCanceled = function (userActionRes) {
                    let userAction = new UserAction(userActionRes);
                    this.userActionsCanceled.push(userAction);
                    $rootScope.$emit("onChangeUserActionToRedo", userAction);
                };

                userActionData.remove = function (userAction) {
                    let index = this.userActions.indexOf(userAction);
                    if (index !== -1)
                        this.userActions.splice(index, 1);
                };
                userActionData.removeCanceled = function (userAction) {
                    let index = this.userActionsCanceled.indexOf(userAction);
                    if (index !== -1)
                        this.userActionsCanceled.splice(index, 1);
                };
                userActionData.clear = function () {
                    userActionData.userActions = [];
                };
                return userActionData;
            }]);



// WEBPACK FOOTER //
// ./js/services/models/userAction.js